import { render } from "./ExpirePs.vue?vue&type=template&id=22381a90&scoped=true&ts=true"
import script from "./ExpirePs.vue?vue&type=script&lang=ts"
export * from "./ExpirePs.vue?vue&type=script&lang=ts"

import "./ExpirePs.vue?vue&type=style&index=0&id=22381a90&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22381a90"]])

export default __exports__